import React from 'react';

/**
 * Small, professional platform-ownership footer.
 * Shown across every Optimar demo surface AND the public verify page.
 * It is intentionally low-contrast: this is product attribution, not a warning.
 *
 * Variants:
 *  - "global"  → flat, low-key strip used inside the global layout footer.
 *  - "card"    → bordered card used at the bottom of public pages.
 */
const PlatformFooter = ({ variant = 'global', className = '', includeDemoNotice = true }) => {
  const base =
    variant === 'card'
      ? 'mt-6 rounded-xl border border-slate-200 bg-white px-4 py-3'
      : 'border-t border-slate-200 bg-white/70 px-4 py-3';

  return (
    <footer
      className={`${base} ${className}`}
      data-testid={`platform-footer-${variant}`}
      aria-label="Platform ownership attribution"
    >
      <p className="text-center text-[11px] leading-relaxed text-slate-500 sm:text-xs">
        <span className="font-semibold text-slate-700">
          PureSustain Platform © PureSustain AS
        </span>{' '}
        ·{' '}
        <span className="text-slate-600">under VeraBlue Capital AS</span>
        {includeDemoNotice && (
          <>
            {' '}
            <span className="mx-1 hidden text-slate-300 sm:inline">|</span>
            <span className="block text-[10px] text-slate-400 sm:inline sm:text-xs">
              Optimar-inspired demo data — this does not represent real
              Optimar customer, plant, SCADA, or production data.
            </span>
          </>
        )}
      </p>
    </footer>
  );
};

export default PlatformFooter;
